import React, { Component } from "react";


const AdminCommands = () => 
{ 
     
       var WEB_URL="https://login.avtbharat.com/";
       //var WEB_URL="http://localhost:3000/"; 
      const strUrl=WEB_URL+"ImpCommands.html";

     return ( 
      <>     
      <div className="top-bar clearfix">
  <div className="row">
  <div className="col-md-4">
   <h2> Help  </h2>             
   </div>

        </div>
      </div >      
       <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div class="card-body p-0">  
       <iframe width="100%" height="780px" src={strUrl}  title="Imp Commands" ></iframe>  
       </div > </div > </div > 
       </>       
       )}; 
   
export default AdminCommands;

